export default () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 9.5H13C13.2652 9.5 13.5196 9.39464 13.7071 9.20711C13.8946 9.01957 14 8.76522 14 8.5V6.5C14 6.23478 13.8946 5.98043 13.7071 5.79289C13.5196 5.60536 13.2652 5.5 13 5.5H11C10.7348 5.5 10.4804 5.60536 10.2929 5.79289C10.1054 5.98043 10 6.23478 10 6.5V7H5.5V5H6C6.26522 5 6.51957 4.89464 6.70711 4.70711C6.89464 4.51957 7 4.26522 7 4V2C7 1.73478 6.89464 1.48043 6.70711 1.29289C6.51957 1.10536 6.26522 1 6 1H4C3.73478 1 3.48043 1.10536 3.29289 1.29289C3.10536 1.48043 3 1.73478 3 2V4C3 4.26522 3.10536 4.51957 3.29289 4.70711C3.48043 4.89464 3.73478 5 4 5H4.5V12C4.5 12.3978 4.65804 12.7794 4.93934 13.0607C5.22064 13.342 5.60218 13.5 6 13.5H10V14C10 14.2652 10.1054 14.5196 10.2929 14.7071C10.4804 14.8946 10.7348 15 11 15H13C13.2652 15 13.5196 14.8946 13.7071 14.7071C13.8946 14.5196 14 14.2652 14 14V12C14 11.7348 13.8946 11.4804 13.7071 11.2929C13.5196 11.1054 13.2652 11 13 11H11C10.7348 11 10.4804 11.1054 10.2929 11.2929C10.1054 11.4804 10 11.7348 10 12V12.5H6C5.86739 12.5 5.74021 12.4473 5.64645 12.3536C5.55268 12.2598 5.5 12.1326 5.5 12V8H10V8.5C10 8.76522 10.1054 9.01957 10.2929 9.20711C10.4804 9.39464 10.7348 9.5 11 9.5ZM4 2H6V4H4V2ZM11 12H13V14H11V12ZM11 6.5H13V8.5H11V6.5Z"
        fill="#7C7C78"
      />
    </svg>
  );
};
